(function() {
    angular
        .module("app")
        .factory("speedLimitTrailersService", speedLimitTrailersService)

        speedLimitTrailersService.$inject = [
        "$rootScope",
        "$http",
        "queryStringService"
    ]

    function speedLimitTrailersService(
        $rootScope,
        $http,
        queryStringService
    ) {
        var service = {}

        /**
            Blank message board display
            @param {int}   messageBoardID
            @param {func?} successCallback
            @param {func?} failureCallback
         **/
        service.setSpeedDisplay = function(messageBoardID, formData, successCallback, failureCallback) {
            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/message_boards/"  + messageBoardID + "/set_speed_display",
                headers: {
                    "Accept": "application/json"
                },
                data: formData
            }).then(completed, failed)

            function completed(response) {
                if (successCallback !== undefined) {
                    successCallback(response)
                }
                return response
            }

            function failed(error) {
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
                console.error(error)
            }
        }

        service.broadcastSpeedDisplay = function(formData, successCallback, failureCallback) {
            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/message_boards/broadcast_speed_display",
                headers: {
                    "Accept": "application/json"
                },
                data: formData
            }).then(completed, failed)

            function completed(response) {
                if (successCallback !== undefined) {
                    successCallback(response)
                }
                return response
            }

            function failed(error) {
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
                console.error(error)
            }
        }

        return service
    }
})()
